export default __webpack_public_path__ + "static/media/personal_booking_icon_other.8710c40f.svg";